import { IconButton, styled } from '@mui/material';

export const PhoneEditor = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  gap: 6,
  '& > div:first-of-type': {
    minWidth: 0,
    flex: '1 1 auto',
  },
});

export const SavePhoneButton = styled(IconButton)(({ theme }) => ({
  width: 34,
  height: 34,
  flex: '0 0 34px',
  borderRadius: 6,
  color: theme.palette.novotalk.$actionButtonColor,
  backgroundColor: theme.palette.novotalk.$selectEnabledBgColorHover,
  '&:hover': {
    backgroundColor: theme.palette.novotalk.$selectEnabledBgColorActive,
  },
  '&:disabled': {
    opacity: 0.55,
  },
}));